import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

// Only adopted grants on real saved profiles are public. Never load reservations.
const cache = new Map<string, { verified: boolean; checkedAt: number }>();
const pending = new Map<string, Promise<boolean>>();
async function check(name: string): Promise<boolean> {
  const key = name.toLowerCase();
  const cached = cache.get(key);
  if (cached && Date.now() - cached.checkedAt < 60_000) return cached.verified;
  const existing = pending.get(key);
  if (existing) return existing;
  const request = (async () => {
    if (!supabase) return false;
    const { data, error } = await supabase.rpc("creator_public_badges", { p_usernames: [name] });
    const verified = !error && Array.isArray(data) && data.some((value: string) => value.toLowerCase() === key);
    if (!error) cache.set(key, { verified, checkedAt: Date.now() });
    return verified;
  })();
  pending.set(key, request);
  try { return await request; } finally { pending.delete(key); }
}

export function VerifiedCreatorMark({ username }: { username: string }) {
  const [verified, setVerified] = useState(false);
  useEffect(() => {
    let active = true;
    setVerified(false);
    void check(username).then((value) => { if (active) setVerified(value); }).catch(() => {});
    return () => { active = false; };
  }, [username]);
  return verified ? <span title="Verified creator" aria-label="Verified creator" style={{ display: "inline-block", marginInlineStart: "0.35em", fontSize: "0.8em" }}>✦✓</span> : null;
}
